import { BasePage } from '@/components/ui/base-page'

export function OveltoPage() {
  return (
    <BasePage
      title="undefined"
      description="undefined"
    >
      {/* Add OveltoPage specific content here */}
    </BasePage>
  )
}